document.addEventListener('DOMContentLoaded', function() {
    var customSelectWrappers = document.querySelectorAll('.custom-select-wrapper');
  
    customSelectWrappers.forEach(function(wrapper) {
      var customSelect = wrapper.querySelector('.custom-select');
      var selectSelected = customSelect.querySelector('.select-selected');
      var selectItems = customSelect.querySelector('.select-items');
      var originalSelect = wrapper.querySelector('select');
  
      originalSelect.addEventListener('change', function() {
        const selectedOption = originalSelect.options[originalSelect.selectedIndex];
        if (selectedOption) {
          selectSelected.textContent = selectedOption.text;
          
          const selectedDiv = selectItems.querySelector(`div[data-value="${selectedOption.value}"]`);
          if (selectedDiv) {
            if (selectedDiv.classList.contains('sold-out')) {
              selectSelected.classList.add('sold-out');
            } else {
              selectSelected.classList.remove('sold-out');
            }
          }
        }
      });
  
      var initialSelectedOption = originalSelect.options[originalSelect.selectedIndex];
      if (initialSelectedOption && initialSelectedOption.value !== "0") {
        selectSelected.textContent = initialSelectedOption.text;
      }
  
      selectItems.classList.add('select-items-up');
  
      selectSelected.addEventListener('click', function(e) {
        e.stopPropagation();
        closeAllSelect(selectSelected);
        selectItems.classList.toggle('select-hide');
        selectSelected.classList.toggle('select-arrow-active');
      });
  
      var options = selectItems.querySelectorAll('div');
      options.forEach(function(option) {
        option.addEventListener('click', function(e) {
          var value = this.getAttribute('data-value');
          var text = this.firstChild.textContent.trim();
  
          selectSelected.textContent = text;
          if (this.classList.contains('sold-out')) {
            selectSelected.classList.add('sold-out');
          } else {
            selectSelected.classList.remove('sold-out');
          }
  
          originalSelect.value = value;
          originalSelect.dispatchEvent(new Event('change'));
  
          var sameAsSelected = selectItems.querySelector('.same-as-selected');
          if (sameAsSelected) {
            sameAsSelected.classList.remove('same-as-selected');
          }
          this.classList.add('same-as-selected');
  
          selectItems.classList.add('select-hide');
          selectSelected.classList.remove('select-arrow-active');

          if (selectSelected.classList.contains('select-color')) {
            const bundleColorChangeEvent = new CustomEvent('bundleColorChange', {
              detail: {
                element: option,
                color: text,
                selectedElement: selectSelected,
                select: originalSelect
              }
            });
            document.dispatchEvent(bundleColorChangeEvent);
          }

          // Check if this is a size selector by looking at the parent wrapper
          const radioButtons = customSelect.closest('.selector-wrapper').querySelector('.select-size');
          
          if (radioButtons) {
            const sizeChangeEvent = new CustomEvent('cartbar:size:change', {
              detail: {
                value: value,
                text: text,
                variantId: this.getAttribute('data-product-variant')
              },
              bubbles: true
            });
            document.dispatchEvent(sizeChangeEvent);
          }

          const isAvailable = !this.classList.contains('sold-out');
          const variantId = this.getAttribute('data-product-variant');
          
          const availabilityEvent = new CustomEvent('variant:availability:change', {
            detail: {
              isAvailable: isAvailable,
              variantId: variantId
            },
            bubbles: true
          });
          document.dispatchEvent(availabilityEvent);
        });
      });
    });
  
    function closeAllSelect(selectSelected) {
      var allSelectItems = document.querySelectorAll('.select-items');
      var allSelectSelected = document.querySelectorAll('.select-selected');
      allSelectItems.forEach(function(item) {
        if (item !== selectSelected.nextElementSibling) {
          item.classList.add('select-hide');
        }
      });
      allSelectSelected.forEach(function(selected) {
        if (selected !== selectSelected) {
          selected.classList.remove('select-arrow-active');
        }
      });
    }
  
    document.addEventListener('click', closeAllSelect);
  
    // Add new event listener for variant URL changes
    document.addEventListener('variant:url:change', function(event) {
      const variantId = event?.detail?.variantId;
      if (!variantId) return;
      
      // Find all custom select wrappers
      customSelectWrappers.forEach(function(wrapper) {
        const selectItems = wrapper.querySelector('.select-items');
        const selectSelected = wrapper.querySelector('.select-selected');
        const originalSelect = wrapper.querySelector('select');
        
            // Find all options and remove same-as-selected class
            const allOptions = selectItems.querySelectorAll('div');
            allOptions.forEach(option => {
              option.classList.remove('same-as-selected');
            });
  
            // Find the option with matching variant ID and add same-as-selected class
            const matchingOption = selectItems.querySelector(`div[data-product-variant="${variantId}"]`);
            
            if (matchingOption) {
              // Add same-as-selected class to matching option
              matchingOption.classList.add('same-as-selected');
  
              // Update the select-selected div with the new value
              const text = matchingOption.querySelector('span').textContent.trim();
              selectSelected.textContent = text;
              
              // Update sold out state
              if (matchingOption.classList.contains('sold-out')) {
                selectSelected.classList.add('sold-out');
              } else {
                selectSelected.classList.remove('sold-out');
              }
              
              // Update original select value
              const value = matchingOption.getAttribute('data-product-variant');
              if (originalSelect && value) {
                originalSelect.value = value;
                originalSelect.dispatchEvent(new Event('variant:url:change', { bubbles: true }));
              }
  
              // Hide dropdown if it's open
              selectItems.classList.add('select-hide');
              selectSelected.classList.remove('select-arrow-active');

              const isAvailable = !matchingOption.classList.contains('sold-out');
              const availabilityEvent = new CustomEvent('variant:availability:change', {
                detail: {
                  isAvailable: isAvailable,
                  variantId: variantId
                },
                bubbles: true
              });
              document.dispatchEvent(availabilityEvent);

              if (typeof window.updateCartBarState === 'function') {
                window.updateCartBarState(isAvailable, variantId);
              }
            }
      });
    });
  });


  if (!customElements.get('color-circle-swatch')) {
    class ColorCircleSwatch extends HTMLElement {
      constructor() {
        super();
        this.items = this.querySelectorAll('div')
        this.activeItem = this.querySelector('div.active')
        this.originalSelect = this.nextElementSibling
        this.items.forEach((item) => {
          item.addEventListener('click', e => this.changeItem(this, e))
        })
      }

      changeItem(elem, e){
        let newItem = e.target.closest('div'),
        text = newItem.getAttribute('data-value');
        if(newItem != this.activeItem){
          this.activeItem = newItem
          this.switchActive(newItem)
          const bundleColorChangeEvent = new CustomEvent('bundleColorChange', {
            detail: {
              element: newItem,
              color: text,
              select: this.originalSelect
            }
          });
          document.dispatchEvent(bundleColorChangeEvent);
        }
      }

      switchActive(newActiveElem){
        this.items.forEach(item => item.classList.remove('active'))
        newActiveElem.classList.add('active')
      }
    }

    customElements.define('color-circle-swatch', ColorCircleSwatch);
  }